export default __webpack_public_path__ + "static/media/DoubleCoinYellow.d7733184.svg";